import Styles from "./CreateNews.module.scss";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import { SwalError, SwalFail, SwalSuccess } from "../../../../Share/Swal";
import { CallApiCreateNew } from "../../../../Api/Enforcement";
import { adminNews } from "../../../../Api/SubUrl";
import NewsForm from "../../../../Components/Molecules/NewsForm";

function CreateNew() {
  const navigate = useNavigate();

  const handleCreateNew = (data, image) => {
    const formattedData = {
      ...data,
      type: data.type.value,
      img: image,
    };
    CallApiCreateNew(formattedData, (res) => {
      if (res === "success") {
        SwalSuccess("Thêm tin tức thành công!");
        navigate(adminNews);
      } else {
        const status = res.Status.status;
        const message = res.Status.data.Message;
        if (status === 400) SwalFail(message);
        else
          SwalError(
            "Đã có lỗi xảy ra!\n Tải lại trang hoặc liên hệ để được hỗ trợ!"
          );
      }
    });
  };

  return (
    <div className={clsx(Styles.main)}>
      <div className={clsx(Styles.topMain)}>
        <h1 className={clsx(Styles.topMainTitle)}>Tạo tin tức</h1>
      </div>
      <div className={clsx(Styles.bodyMain)}>
        <NewsForm onSubmit={handleCreateNew} buttonText="Thêm" />
      </div>
    </div>
  );
}

export default CreateNew;
